export default "__VITE_ASSET__CPAKrqep__"